export default [
    {
        path: '/administracion-solicitud/index',
        name: 'AdministracionSolicitudView',
        component: () => import('../views/aseguradora/ajustePoliza/AdministracionSolicitudView.vue')
    },
    {
        path: '/ingreso-documento-manual/index',
        name: 'IngresoDocumentoManualView',
        component: () => import('../views/aseguradora/ajustePoliza/IngresoDocumentoManualView.vue')
    },
    {
        path: '/inclusion/index',
        name: 'InclusionView',
        component: () => import('../views/aseguradora/ajustePoliza/InclusionView.vue')
    },
    {
        path: '/exclusion/index',
        name: 'ExclusionView',
        component: () => import('../views/aseguradora/ajustePoliza/ExclusionView.vue')
    },
    {
        path: '/cancelacion/index',
        name: 'CancelacionView',
        component: () => import('../views/aseguradora/ajustePoliza/CancelacionView.vue')
    },
    {
        path: '/renovacion/index',
        name: 'RenovacionView',
        component: () => import('../views/aseguradora/ajustePoliza/RenovacionView.vue')
    },
]